import type { StoredAssessmentState } from "../types/friction-finder";

export const ASSESSMENT_STORAGE_KEY = "huddleco.friction-finder.v1";

export function saveAssessmentState(state: StoredAssessmentState, storage: Storage = window.sessionStorage): void {
  storage.setItem(ASSESSMENT_STORAGE_KEY, JSON.stringify(state));
}

export function restoreAssessmentState(storage: Storage = window.sessionStorage): StoredAssessmentState | null {
  try {
    const raw = storage.getItem(ASSESSMENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as StoredAssessmentState;
    if (parsed.version !== 1 || !parsed.assessmentSessionId || !parsed.answers) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function clearAssessmentState(storage: Storage = window.sessionStorage): void {
  storage.removeItem(ASSESSMENT_STORAGE_KEY);
}
